<div class="ui-login">
    <div class="ui-login-area">
        <div class="ui-login-logo"></div>

        <div class="ui-login-form" *ngIf="screen == 'login'">
            <form>
                <div class="ui-login-message" *ngIf="response">{{response.message}}</div>

                <mat-form-field class="ui-field">
                    <mat-label>Usuario</mat-label>
                    <input matInput type="text" name="user" [(ngModel)]="user">
                </mat-form-field>
                <mat-form-field class="ui-field ui-field-password">
                    <mat-label>Contraseña</mat-label>
                    <input matInput [attr.type]="(passwordVisibility ? 'text' : 'password')" name="password" [(ngModel)]="password">
                    <mat-icon class="ui-icon" matSuffix (click)="onTogglePassword()">{{(passwordVisibility ? 'visibility_off' : 'visibility_on')}}</mat-icon>
                </mat-form-field>

                <div class="ui-login-form-actions">
                    <a (click)="setLocation('recuperar')">Olvidé mi contraseña</a>
                </div>
                
                <div class="ui-login-form-button">
                    <button type="submit" mat-flat-button color="primary" class="ui-button" (click)="onLogin()" *ngIf="!request">Ingresar</button>
                    <mat-spinner class="ui-spinner" [diameter]="36" *ngIf="request"></mat-spinner>
                </div>

                <mat-icon class="ui-icon ui-biometric-icon" (click)="biometricAuth()" *ngIf="biometricAvailable">fingerprint</mat-icon>
            </form>
        </div>

        <div class="ui-login-form" *ngIf="screen == 'recover'">
            <h1>Recuperar mi contraseña</h1>
            <p>Recibiras un correo para que verifiques la creación de tu nueva contraseña.</p>
            
            <div class="ui-login-message" *ngIf="response">{{response.message}}</div>

            <mat-form-field class="ui-field">
                <mat-label>Usuario</mat-label>
                <input matInput type="text" placeholder="Usuario" [(ngModel)]="user">
            </mat-form-field>

            <div class="ui-login-form-actions">
                <a (click)="setLocation('ingreso')">Ingresar</a>
            </div>
            
            <div class="ui-login-form-button">
                <button mat-flat-button color="primary" class="ui-button" (click)="onRecover()" *ngIf="!request">Recuperar contraseña</button>     
                <mat-spinner class="ui-spinner" [diameter]="36" *ngIf="request"></mat-spinner>
            </div>
        </div>

        <div class="ui-login-form" *ngIf="screen == 'restore'">
            <h1>Restablecer mi contraseña</h1>
            <p>Estas a punto de restablecer tu contraseña. Si continúas te enviaremos un email con tu nueva contraseña.</p>
            
            <div class="ui-login-message" *ngIf="response">{{response.message}}</div>
            
            <div class="ui-login-form-actions">
                <a (click)="setLocation('ingreso')">Ingresar</a>
            </div>
            
            <div class="ui-login-form-button">
                <button mat-flat-button color="primary" class="ui-button" (click)="onRestore()" *ngIf="!request">Restablecer contraseña</button>     
                <mat-spinner class="ui-spinner" [diameter]="36" *ngIf="request"></mat-spinner>
            </div>
        </div>

        <div class="ui-login-form" *ngIf="screen == 'register'">
            <h1>Activar cuenta</h1>
            <p>Al continuar activaremos tu cuenta y te enviaremos por correo tu contraseña para que puedas acceder.</p>
            
            <div class="ui-login-message" *ngIf="response">{{response.message}}</div>
            
            <div class="ui-login-form-actions">
                <a (click)="setLocation('ingreso')">Ingresar</a>
            </div>
            
            <div class="ui-login-form-button">
                <button mat-flat-button color="primary" class="ui-button" (click)="onActivate()" *ngIf="!request">Activar cuenta</button>     
                <mat-spinner class="ui-spinner" [diameter]="36" *ngIf="request"></mat-spinner>
            </div>
        </div>

        <div class="ui-login-accounts" *ngIf="screen == 'accounts'">
            <h1>Bienvenido!</h1>
            <p>Seleccioná la cuenta que necesitas administrar.</p>
            <div>
                <a class="ui-shadow" (click)="onAccountSelect(account.number)" *ngFor="let account of currentUser.accounts">
                    <div>
                        <h1>{{account.name}}</h1><span>{{account.number}} - {{accountStatus(account.status)}}</span>
                    </div>
                    <mat-icon aria-label="Seleccionar">navigate_next</mat-icon>
                </a>
            </div>
           
            <div style="margin-top:60px;" *ngIf="currentUser.isAdmin">
                <h1>Cuenta de clientes</h1>
                <p>Busca una cuenta de cliente para administrar</p>
                <div>
                    <ui-autocomplete 
                        [data]="adminAccountsDataFiltered | async"
                        [display]="adminAccountsDataDisplay.bind(this)"
                        [loading]="adminAccountsLoading"
                        value="number"
                        name="name"
                        placeholder="Número de cliente, DNI, Teléfono o Email"
                        (onChange)="adminAccounts.next($event)"
                    ></ui-autocomplete>
                </div>

                <div class="ui-login-form-button">
                    <button type="submit" mat-flat-button color="primary" class="ui-button" (click)="onAccountSelect(adminAccountsValue)" [disabled]="adminAccountsValue <= 0" *ngIf="!request">Continuar</button>
                    <mat-spinner class="ui-spinner" [diameter]="36" *ngIf="request"></mat-spinner>
                </div>
            </div>
        </div>
    </div>

    <a class="ui-developer" (click)="onDevInfo()">
        <img src="assets/images/clousis.svg" title="Desarrollador">
    </a>
</div>